const SummaryTableSchema = [
    {
        objectName: 'selectedProductReceiptLine',
        children: [
            {
                label: 'PRODUCT',
                fieldNames: [
                    'ProductIdDisplay',
                    'Description'
                ],
                valueRenderer: {
                    api: {
                        api: '/inventoryEnquiry/lookup/action',
                        name: 'enquiry',
                        params: {
                            queryFields: {
                                ProductId: 'ProductId'
                            }
                        }
                    }
                }
            },
            {
                label: 'SUPPLIER PRODUCT',
                fieldNames: [
                    'SupplierProduct',
                ]
            },
        ]
    },
    {
        objectName: 'selectedProductReceiptLine',
        label: 'Purchase order details',
        style: {
            marginTop: 20,
        },
        children: [
            {
                label: 'PURCHASE ORDER',
                fieldNames: [
                    'PurchaseOrder'
                ],
            },
            {
                label: 'LINE',
                fieldNames: [
                    'PurchaseOrderLineNumber'
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'BUY UNIT',
                fieldNames: [
                    'BuyUnit'
                ],
            },
            {
                label: 'QUANTITY',
                fieldNames: [
                    'QuantityDisplay'
                ],
                valueRenderer: {
                    isNumeric: true,
                }
            },
            {
                label: 'CONVERSION',
                fieldNames: [
                    'UnitConversionDisplay'
                ],
                valueRenderer: {
                    isNumeric: true,
                }
            },
            {
                label: 'PRICE',
                fieldNames: [
                    'PriceDisplay'
                ],
                valueRenderer: {
                    isNumeric: true,
                }
            },
            {
                label: 'TAX IINCLUDED PRICES',
                fieldNames: [
                    'TaxIncludedDisplay',
                ],
            },
        ]
    },
    {
        objectName: 'ProductReceiptLinePricing',
        label: 'Pricing details',
        style: {
            marginTop: 20,
        },
        children: [
            {
                label: 'ON HAND',
                fieldNames: [
                    'OnhandQuantityDisplay'
                ],
                valueRenderer: {
                    isNumeric: true,
                }
            },
            {
                label: 'NEW ON HAND',
                fieldNames: [
                    'NewOnhandQuantityDisplay'
                ],
                valueRenderer: {
                    isNumeric: true,
                }
            },
            {
                label: 'STOCK UNIT',
                fieldNames: [
                    'StockUnit'
                ],
            },
            {
                label: 'LAST COST',
                fieldNames: [
                    'LastCostDisplay',
                ],
                valueRenderer: {
                    isNumeric: true,
                }
            },
            {
                label: 'AVERAGE COST',
                fieldNames: [
                    'AverageCostDisplay',
                ],
                valueRenderer: {
                    isNumeric: true,
                }
            },
            {
                label: 'NEW COST',
                fieldNames: [
                    'NewCostDisplay',
                ],
                valueRenderer: {
                    isNumeric: true,
                }
            },
            {
                label: 'BASE PRICE',
                fieldNames: [
                    'BasePriceDisplay',
                ],
                valueRenderer: {
                    isNumeric: true
                }
            },
            {
                label: 'OLD GP %',
                fieldNames: [
                    'OldGPDisplay',
                ],
                valueRenderer: {
                    isNumeric: true,
                }
            },
            {
                label: 'NEW GP %',
                fieldNames: [
                    'NewGPDisplay',
                ],
                valueRenderer: {
                    isNumeric: true,
                }
            },
        ]
    },

];

export default SummaryTableSchema;
